// Copyright (c) 2016 Deere & Company

import './create-claim-modal.scss';
import React, {PropTypes} from 'react';
import CreateClaimModalBody from './create-claim-modal-body';
import CreateClaimModalHeader from './create-claim-modal-header';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {WarrantyMediumModal} from '../../../shared/components/modal';

const CreateClaimModal = props =>
    <WarrantyMediumModal
        className='create-claim-modal'
        isOpen={props.isModalOpen}
    >
        <CreateClaimModalHeader
            onCloseButtonClick={props.onCloseButtonClick}
        />
        <CreateClaimModalBody
            claimTypes={props.claimTypes}
            onClick={props.onClick}
            selectedPin={props.selectedPin}
        />
    </WarrantyMediumModal>;

CreateClaimModal.displayName = 'CreateClaimModal';
CreateClaimModal.propTypes = {
    claimTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onCloseButtonClick: PropTypes.func.isRequired,
    selectedPin: PropTypes.string
};

export default CreateClaimModal;



// WEBPACK FOOTER //
// ./src/shared/components/create-claim-modal/index.js